<template>
  <div class="centerTop">
    <!-- <div class="title">大厅实时服务明细分析</div> -->
    <div id="map-chart"></div>
  </div>
</template>

<script>
import apiPath from '@config/api.json'
import common from '@/utils/common'
const $ = require('jquery')
const {mapState, mapMutations} = require('vuex')
// 航线上的飞机模型的矢量图
var planePath = 'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z'
export default {
  components: {},

  data () {
    return {
      myEcharts: null,
      listData: null,
      BJData: [],
      globalObj: null, // 地图对象
      globalOption: '',
      curMapName: 'Global', // 当前地图名称
      statisticsObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  // created () {
  //   common.getAllRegionData()
  // },

  mounted () {
    this.init()
    this.statisticsObj = setInterval(() => {
      this.loadMapDataInfo()
    }, 60000)
  },

  methods: {
    ...mapMutations({}),
    init () {
      this.loadGlobalMap(this.curMapName)
    },
    // 用于返回起点名字、终点名字、起点坐标、终点坐标
    returnCoords (dataInfo) {
      let result = []
      dataInfo.forEach(item => {
        const fromcoords = common.getLonLat(item['startDid'])
        const countryCode = common.getLonLat(item['countryDid'])
        result.push({
          fromname: item['startCountry'],
          toname: item['country'],
          coords: [fromcoords, countryCode],
          value: item['transaction']
        })
      })
      return result
    },
    // 返回航线和飞机的颜色：三种颜色（起点为广州的、上海的、北京的）
    returnColor (index) {
      return index === 0 ? '#6beef4' : (index === 1 ? '#ecc021' : '#73fa3b')
    },
    /**
     * 世界地图
     * mapName 地图名称
     * geoCoordMapObj 地理坐标 （东经北纬）
     * */
    loadGlobalMap (mapName, geoCoordMapObj) {
      const mapContanier = document.getElementById('map-chart')
      var geo = {
        map: mapName, // 名称
        top: 100, // 地图与顶部距离
        roam: true, // scale、move
        zoom: 1.4,
        scaleLimint: {min: 0.5, max: 3},
        label: {
          emphasis: {
            show: true,
            textStyle: {
              color: '#fffefe'
            }
          }
        },
        itemStyle: {
          normal: {
            areaColor: '#1e3d79',
            borderColor: 'rgba(0,0,0,.4)'
          },
          emphasis: {
            areaColor: '#244995',
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowBlur: 20,
            borderWidth: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },

        // 标志当前
        regions: [{
          name: this.curCountryName,
          selected: false,
          label: {
            normal: {
              show: true,
              textStyle: {color: '#33bf64'}
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#1e3d79',
              borderColor: 'rgba(0, 0, 0, 0.5)',
              opacity: 1
            },
            emphasis: {
              opacity: 0.8
            }
          }
        }, {
          name: '',
          selected: false,
          label: {
            normal: {
              show: true,
              textStyle: {color: '#33bf64'}
            }
          }
        }]
      }
      var series = []
      common.isLoadEchart(() => {
        // 美国地图时，将阿拉斯加移到美国主大陆左下方
        let addiInfo = null
        if (this.curMapName === 'United States') {
          addiInfo = {
            Alaska: { // 把阿拉斯加移到美国主大陆左下方
              left: -125,
              top: 25,
              width: 60
            },
            Hawaii: {
              left: -130, // 夏威夷
              top: 25,
              width: 25
            },
            'Puerto Rico': { // 波多黎各
              left: -76,
              top: 26,
              width: 10
            }
          }
        }

        let setJson = '/static/json/' + decodeURI(this.curMapName) + '.json'
        $.getJSON(setJson, (mapData) => {
          this.globalObj && this.globalObj.dispose()
          window.echarts.registerMap(mapName, mapData, addiInfo)
          this.globalObj = window.echarts.init(mapContanier)
          this.globalOption = {
            tooltip: {
              trigger: 'item',
              backgroundColor: '#31357c',
              borderColor: '#ccc',
              borderWidth: 1,
              padding: [5, 10, 5, 10],
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);opacity:0.8;',
              formatter: function (obj) {
                if (obj.data) {
                  return obj.data.fromname + '->' + obj.data.toname + '<br/>' + common.formatNumber(obj.data.value)
                }
              }
            },
            geo: geo,
            series: series
          }
          this.globalObj.setOption(this.globalOption)
          this.loadMapDataInfo()
        })
      })
    },
    // 加载地图映射的数据
    loadMapDataInfo () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.home.centerCenter.getOrderSalesToday}`
        // params: {
        //   yearTime: this.homeTime
        // }
      }).then(res => {
        // 地图映射坐标点
        let dataInfo = res.data.list || []
        // 设置参数 选中相应的国家地图
        this.globalOption.series = this.globaSeries(dataInfo)
        // 设置地图参数
        this.globalObj.setOption(this.globalOption)
      })
    },
    // 动态数据
    globaSeries (itemArr) {
      var series = [
        {
          type: 'lines', // series.type = "lines"表名是想渲染模拟迁徙的模板
          //  type: 'lines', // series.type = "lines"表名是想渲染模拟迁徙的模板
          zlevel: 0, // zleve控制飞机的图标的分层
          effect: {
            show: true,
            symbol: planePath, // 把矢量图planPath赋值给symbol
            symbolSize: 18, // 控制矢量图的大小,
            loop: true, // 是否循环播放
            period: 60 // 飞机飞行时间。默认4秒
          },
          // 线条的样式
          lineStyle: {
            curveness: 0.7, // 控制线条的弯曲度
            color: this.returnColor(0), // 不同的起点显示不同的线条样式
            width: 1 // 线条的宽度
          },
          animation: true,
          animationDuration: 1000,
          data: this.returnCoords(itemArr) // 所有的航线起始地点的数据
        }
        // {
        //   type: 'effectScatter', // 带有涟漪特效动画的散点（气泡）图。利用动画特效可以将某些想要突出的数据进行视觉突出。
        //   coordinateSystem: 'geo', // 该系列使用的坐标系
        //   zlevel: 2,
        //   rippleEffect: { // 涟漪特效相关配置
        //     brushType: 'stroke'
        //   },
        //   label: { // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
        //     show: true,
        //     position: 'right',
        //     formatter: '{b}'
        //   },
        //   symbolSize: function (val) { // 标记的大小
        //     let data = 20
        //     // if (val) data = val[2] / 100
        //     return data
        //   },
        //   itemStyle: {
        //     color: '#46bee9'
        //   },
        //   data: tips
        //   // data: item[1].map((dataItem)=> {
        //   //   console.log(dataItem)
        //   //   return {
        //   //     name: item[1].name,
        //   //     value: item[1].value
        //   //   };
        //   // })
        // }
      ]
      return series
    }
  },
  beforeDestroy () {
    clearInterval(this.statisticsObj)
  }
}
</script>

<style lang="scss" scoped>
  .centerTop{
    // position: fixed;
    // top: 20%;
    // left: 0;
    // width: 100%;
    // height: 80%;
    // #map-chart {
    //   width: 1200px;
    //   height: 800px;
    //   margin: 0 auto;
    // }
    width: 900px;
    height: 555px;
    #map-chart {
      width: 900px;
      height: 555px;
    }
    // background: url('~@/assets/images/home/centerTop-bg.png') no-repeat 0 0;
    // background-size:100% 100%;
    .title{
      height: 18px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #00FAFF;
      width: 100%;
      line-height: 18px;
      margin-top: 20px;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/centerTop.vue